<template>
  <div v-if="serviceOrder" class="container">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <div class="header">
      <Message
        severity="error"
        :closable="false"
        icon="pi-exclamation-triangle"
        v-if="!serviceOrder.pat_id || serviceOrder.accepted == 0"
      >
        <span class="p-d-flex p-ai-center p-jc-between">
          <span v-if="!serviceOrder.pat_id"> Pat da Ordem de Serviço não está Criado </span>
          <span v-else> Ordem de Serviço não foi aceite </span>
          <Button
            :label="!serviceOrder.pat_id ? 'Criar' : 'Aceitar'"
            icon="pi pi-check-circle"
            class="p-button-sm p-button-info"
            @click="createPat"
            v-if="can('createPatFromHisenseServiceOrder')"
          />
        </span>
      </Message>
    </div>
    <div class="content">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="service_order_id"
              name="service_order_id"
              type="text"
              v-model="serviceOrder.service_order_id"
              :disabled="true"
            />
            <label for="service_order_id">Referência</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="service_order_no"
              name="service_order_no"
              type="text"
              v-model="serviceOrder.service_order_no"
              :disabled="true"
            />
            <label for="service_order_no">Nº Ordem de Serviço</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="pat_id"
              name="pat_id"
              type="text"
              v-model="serviceOrder.pat_id"
              :disabled="true"
            />
            <label for="pat_id">Pat</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="problem"
              name="problem"
              type="text"
              v-model="serviceOrder.problem"
              :disabled="true"
            />
            <label for="problem">Problema</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="order_type"
              name="order_type"
              type="text"
              v-model="serviceOrder.order_type"
              :disabled="true"
            />
            <label for="order_type">Tipo da Ordem de Serviço</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="order_status"
              name="order_status"
              type="text"
              v-model="serviceOrder.order_status"
              :disabled="true"
            />
            <label for="order_status">Estado da Ordem de Serviço</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="created_user"
              name="created_user"
              type="text"
              v-model="serviceOrder.created_user"
              :disabled="true"
            />
            <label for="created_user">Criado por</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="created_date"
              name="created_date"
              type="text"
              v-model="serviceOrder.created_date"
              :disabled="true"
            />
            <label for="created_date">Data da Criação</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="assign_date"
              name="assign_date"
              type="text"
              v-model="serviceOrder.assign_date"
              :disabled="true"
            />
            <label for="assign_date">Data de Atribuição</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="reservation_date"
              name="reservation_date"
              type="text"
              v-model="serviceOrder.reservation_date"
              :disabled="true"
            />
            <label for="reservation_date">Data de Recepção</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="warranty_type"
              name="warranty_type"
              type="text"
              v-model="serviceOrder.warranty_type"
              :disabled="true"
            />
            <label for="warranty_type">Tipo de Garantia</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="problem_note"
              name="problem_note"
              type="text"
              v-model="serviceOrder.problem_note"
              :disabled="true"
            />
            <label for="problem_note">Nota do problema</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <Textarea
              id="repair_note"
              name="repair_note"
              type="text"
              :autorezie="true"
              v-model="serviceOrder.repair_note"
              :disabled="true"
            />
            <label for="repair_note">Nota de Reparação</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="product_id"
              name="product_id"
              type="text"
              v-model="serviceOrder.product_id"
              :disabled="true"
            />
            <label for="product_id">Id do Produto</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_model"
              name="customer_model"
              type="text"
              v-model="serviceOrder.customer_model"
              :disabled="true"
            />
            <label for="customer_model">Modelo do Produto</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="serial_number"
              name="serial_number"
              type="text"
              v-model="serviceOrder.serial_number"
              :disabled="true"
            />
            <label for="serial_number">Serial Number</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="external_reference"
              name="external_reference"
              type="text"
              v-model="serviceOrder.external_reference"
              :disabled="true"
            />
            <label for="external_reference">Referência Externa</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="purchase_date"
              name="purchase_date"
              type="text"
              v-model="serviceOrder.purchase_date"
              :disabled="true"
            />
            <label for="purchase_date">Data da Compra</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_first_name"
              name="customer_first_name"
              type="text"
              v-model="serviceOrder.customer_first_name"
              :disabled="true"
            />
            <label for="customer_first_name">Cliente Nome</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_last_name"
              name="customer_last_name"
              type="text"
              v-model="serviceOrder.customer_last_name"
              :disabled="true"
            />
            <label for="customer_last_name">Cliente Apelido</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_telephone"
              name="customer_telephone"
              type="text"
              v-model="serviceOrder.customer_telephone"
              :disabled="true"
            />
            <label for="customer_telephone">Cliente Telefone</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_mobil_phone"
              name="customer_mobil_phone"
              type="text"
              v-model="serviceOrder.customer_mobil_phone"
              :disabled="true"
            />
            <label for="customer_mobil_phone">Cliente Telemóvel</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_email"
              name="customer_email"
              type="text"
              v-model="serviceOrder.customer_email"
              :disabled="true"
            />
            <label for="customer_email">Cliente Email</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_address_1"
              name="customer_address_1"
              type="text"
              v-model="serviceOrder.customer_address_1"
              :disabled="true"
            />
            <label for="customer_address_1">Cliente Morada 1</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_address_2"
              name="customer_address_2"
              type="text"
              v-model="serviceOrder.customer_address_2"
              :disabled="true"
            />
            <label for="customer_address_2">Cliente Morada 2</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_address_3"
              name="customer_address_3"
              type="text"
              v-model="serviceOrder.customer_address_3"
              :disabled="true"
            />
            <label for="customer_address_3">Cliente Morada 3</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_zip_code"
              name="customer_zip_code"
              type="text"
              v-model="serviceOrder.customer_zip_code"
              :disabled="true"
            />
            <label for="customer_zip_code">Cliente Código Postal</label>
          </span>
        </div>
        <div class="p-col-12 p-md-12 p-mt-5">
          <span class="p-float-label">
            <InputText
              id="customer_city"
              name="customer_city"
              type="text"
              v-model="serviceOrder.customer_city"
              :disabled="true"
            />
            <label for="customer_city">Cliente Localidade</label>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import serviceOrdersService from "../../services/serviceOrders.service";
export default {
  name: "DetailHisense",
  props: ["serviceOrder"],
  methods: {
    createPat() {
      return serviceOrdersService
        .serviceOrderHisenseCreatePat(this.serviceOrder.id)
        .then((response) => {
          if (response.error !== undefined) {
            return this.$toast.add({
              severity: "error",
              summary: `Ocorreu um erro`,
              detail: response.error,
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Ordem Serviço Atualizada`,
            detail: "",
            life: 3000,
          });
          return this.$emit("createPatAcceptService", response);
        });
    },
  },
};
</script>
<style>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.content {
  overflow: auto;
  padding: 10px;
}
</style>
<style lang="css" scoped>
:deep(.p-message-text) {
  width: 100% !important;
}
</style>
